/**
 * Mappers for security grouping list operations
 */

import type {
  LC_SecurityGroupItem,
  LC_SecurityGroupListOut,
  SecurityGroupItem,
  SecurityGroupListResult,
} from '../types';


/**
 * Map single security group item from transport to domain model
 */
export function mapSecurityGroupItemToModel(
  transport: LC_SecurityGroupItem,
): SecurityGroupItem {
  return {
    id: transport.id,
    code: transport.code,
    name: transport.groupName,
    isEnabled: transport.enabled,
    createdDate: transport.createdAt,
    createdBy: transport.createdBy,
    sendsAttendanceStatus: transport.sendsAttendanceStatus,
    modifiedDate: transport.modifiedAt,
    modifiedBy: transport.modifiedBy,
    idRex: transport.idrex,
    isRexActive: transport.isRexActive ?? false,
  };
}

/**
 * Map paginated security groups list from transport to domain
 */
export function mapSecurityGroupListPagedResultToModel(
  transport: LC_SecurityGroupListOut,
): SecurityGroupListResult {
  return {
    items: transport.data ? transport.data.map(mapSecurityGroupItemToModel) : [],
    page: transport.pagination.currentPage,
    pageSize: transport.pagination.pageSize,
    totalRecords: transport.pagination.totalRecords,
    totalPages: transport.pagination.totalPages,
  };
}
